<template>
    <div
        v-if="showServerError"
        class="servererror"
    >
        <h3 class="icon--center">
            <icon-base
                type="icon"
                name="attention"
                additional-css-classes="icon--large"
            />
            {{ errorHeading }}
        </h3>
        <p/>
        <p>{{ errorMessage }}</p>
        <p/>
    </div>
</template>

<script>
import {defineComponent} from "vue";
import IconBase from "@/components/IconBase";

export default defineComponent({
    name: "ServerError",
    components: {IconBase},
    props: {
        errorMessage: {
            type: String,
            required: true
        },
        show: {
            type: Boolean,
            default: false
        },
        errorHeading: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            showServerError: false
        }
    },
    watch: {
        show() {
            this.showServerError = this.show
        }
    },
    updated() {
        this.showServerError = this.show;
    }
});
</script>

<style scoped lang="less">

.mod-calculator {

    .servererror {

        padding-left: 10px;

        &:before {
            display: none;
        }
    }
}
</style>
